export default __webpack_public_path__ + "dist/media/MessageQuote.f1bb60e4.svg";